import config from '../config';
import multicall_abi from './json/multicall';
import ERC20_abi from './json/ERC20';
import cERC20_abi from './json/cERC20';
import yERC20_abi from './json/yERC20';
import idleERC20_abi from './json/idleERC20';
import synthERC20_abi from './json/synthERC20';
import iearnAPR_abi from './json/iearn/apr';
import registry_abi from './json/registry';
import synthetixExchanger_ABI from './json/synthetixExchanger';
import adapterABI from './json/adapter';
import sbtcRewards_ABI from './json/sbtcRewards';
import balancer_ABI from './json/balancer';
import minter_ABI from './json/minter';
import gaugecontroller_abi from './json/gaugecontroller';
import votingescrow_abi from './json/votingescrow';
import liquiditygauge_abi from './json/liquiditygauge';
import liquiditygauge_v2 from './json/liquiditygauge_v2';
import liquiditygauge_v3 from './json/liquiditygauge_v3'; //matig gauge no rewards
import liquiditygauge_v4 from './json/liquiditygauge_v4'; // new ben gauges
import streamer_abi from './json/streamer'
import migratorABI from './json/migratorabi'

import cross_asset_swaps from './json/cross_asset_swaps';
import fee_distro_abi from './json/fee_distro';
import usdn_rewards from './json/usdn_rewards';
import system_status_snx_abi from './json/system_status_snx';
import susdSwapABI from './json/susd/swap';

const infura_url = config.rpcUrl;

const iearnAPR_address = '0x4100FB8d05e37a897ACB686AAc833DD7e49aa591';
const synthetixExchanger_address = '0x0bfDc04B38251394542586969E2356d0D731f7DE'
const registry_address = '0x7002B727Ef8F5571Cb5F9D70D13DBEEb4dFAe9d1'
const adapterAddress = '0x9fe350DfA5F66bC086243F21A8F0932514316627'
const sbtcRewards_address = '0x13C1542A468319688B89E323fe9A3Be3A90EBb27'
const balancer_address = '0x330416C863f2acCE7aF9C9314B422d24c672534a'
const CHI_address = '0x0000000000004946c0e9F43F4Dee607b0eF1fA1c'
const minter_address = '0xd061D61a4d941c39E5453435B6345Dc261C2fcE0'
const gaugecontroller_address = '0x2F50D538606Fa9EDD2B11E2446BEb18C9D5846bB'
const votingescrow_address = '0x5f3b5DfEb7B28CDbD7FAba78963EE202a494e2A2'
const cross_addet_swap_address = '0x58A3c68e2D3aAf316239c003779F71aCb870Ee47'
const CRV_address = '0xD533a949740bb3306d119CC777fa900bA034cd52'
const fee_distro_address = '0xA464e6DCda8AC41e03616F95f4BC98a13b8922Dc'
const system_status_snx = '0x1c86B3CDF2a60Ae3a574f7f71d44E2C50BDdB87E';

const susd = {
    swap_abi: susdSwapABI,
    swap_address: '0xeDf54bC005bc2Df0Cc6A675596e843D28b16A966',
    token_address: '0x2b645a6A426f22fB7954dC15E583e3737B8d1434',
    gauge_address: '0xBC89cd85491d81C6AD2954E6d0362Ee29fCa8F53',
    N_COINS: 2,
    tethered: [false, false],
    use_lending: [true, true],
    is_plain: [false, false],
    coin_precisions: [1e18, 1e18],
    underlying_coins: [
        '0x57Ab1ec28D129707052df4dF418D58a2D46d5f51',
        '0xdF5e0e81Dff6FAF3A7e52BA697820c5e32D806A8',
    ],
    coins: [
        '0xF61718057901F84C4eEC4339EF8f0D86D2B45600',
        '0xdF5e0e81Dff6FAF3A7e52BA697820c5e32D806A8',
    ],
};

export {
    infura_url,
    multicall_abi,
    ERC20_abi,
    cERC20_abi,
    yERC20_abi,
    idleERC20_abi,
    synthERC20_abi,
    iearnAPR_abi,
    iearnAPR_address,
    registry_abi,
    synthetixExchanger_ABI,
    adapterABI,
    sbtcRewards_ABI,
    balancer_ABI,
    minter_ABI,
    gaugecontroller_abi,
    votingescrow_abi,
    liquiditygauge_abi,
    liquiditygauge_v2 as liquiditygauge_abi_v2,
    liquiditygauge_v3,
    liquiditygauge_v4,
    cross_asset_swaps,
    fee_distro_abi,
    usdn_rewards,
    system_status_snx_abi,
    synthetixExchanger_address,
    registry_address,
    adapterAddress,
    sbtcRewards_address,
    balancer_address,
    CHI_address,
    minter_address,
    gaugecontroller_address,
    votingescrow_address,
    cross_addet_swap_address,
    CRV_address,
    fee_distro_address,
    system_status_snx,
    susd,
    streamer_abi,
    migratorABI
};
